import ss from 'socket.io-stream'
import {b64toBlob} from "../../../../helpers";
import {getSocket} from "../../../../sockets";
import MAYA from "../../../../maya_api";

export default async function uploadPhoto(photo) {
  const socket = getSocket();
  if(!photo) return null;

  let image = new Image;
  image.src = photo;

  image.onload = async() => {
    const width = image.width;
    const height = image.height;

    const encodedSession = await MAYA.getEncodedSession();

    let stream = ss.createStream();

    ss(socket).emit('/h/camera/images', {
      images: [{
        argument: 1,
        size: 100,
        format: 'jpg',
        width: width,
        height: height,
        stream: stream
      }],
      device_guid: encodedSession.device_guid,
      server_data: encodedSession.encoded_session_data
    });

    const cleanBase64 = photo.replace(/^[^,]+,/, '');
    ss.createBlobReadStream(b64toBlob(cleanBase64)).pipe(stream);
  };

}




// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/modules/uploadPhoto.js